import { useTranslations } from '@vocab/react';
import { Box, Columns, Column, Stack, Text } from 'braid-design-system';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import {
  FEATURE_PER_UNIT_BILLING,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import type { AppState } from 'src/types/appState';

import translations from './.vocab';
import Tick from './Tick';

export const ThankYouTick = () => {
  const { firstName, flowType } = useSelector(
    (state: AppState) => ({
      firstName: state.session.userFirstName,
      flowType: state.formData.flowType,
    }),
    shallowEqual,
  );

  const { t } = useTranslations(translations);

  const getAction = () => {
    if (flowType === 'refresh') {
      return t('thank-you-tick-action-refresh');
    } else if (flowType === 'edit') {
      return t('thank-you-tick-action-edit');
    }
    return t('thank-you-tick-action-create');
  };

  const isPerUnitBilling = useFeatureToggleData(FEATURE_PER_UNIT_BILLING);

  const isShowTextOnSEEK = () => (flowType === 'create' ? ' on SEEK' : '');
  const getThankYouTickHeading = () => {
    if (isPerUnitBilling) {
      return t('thank-you-tick-heading-cpqa', {
        firstName,
      });
    }
    const translationName =
      flowType === 'create'
        ? 'thank-you-tick-heading'
        : 'thank-you-tick-heading-2';
    return t(translationName, {
      firstName,
    });
  };

  const subHeadingTranslation = isPerUnitBilling
    ? 'thank-you-tick-subheading-cpqa'
    : 'thank-you-tick-subheading';

  return (
    <Columns space="none">
      <Column width="content">
        <Tick />
      </Column>
      <Column>
        <Box
          alignItems="center"
          display="flex"
          height="full"
          paddingLeft="medium"
        >
          <Stack space="medium">
            <Text size="standard" weight="medium">
              {getThankYouTickHeading()}
            </Text>
            <Text size="standard" weight="medium">
              {`
                ${
                  t(subHeadingTranslation, {
                    actionName: getAction(),
                  }) + isShowTextOnSEEK()
                }.
              `}
            </Text>
          </Stack>
        </Box>
      </Column>
    </Columns>
  );
};
